import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-t-small', 'IconLetterTSmall', [
  ['path', { d: 'M10 8h4', key: 'svg-0' }],
  ['path', { d: 'M12 8v8', key: 'svg-1' }],
]);
